import _ from 'underscore';

export const getHelpLibraryResults = ({ query }) => {
  let searchResult = [];
  if (window.ApexPlatform && _.isFunction(window.ApexPlatform.AutoSuggestions)) {
    try {
      searchResult = window.ApexPlatform.AutoSuggestions(query) || [];

      // validate the search result
      if (!_.isArray(searchResult)) {
        searchResult = [];
      } else {
        for (let i = 0; i < searchResult.length; i += 1) {
          const { suggestion, video, url } = searchResult[i];
          if (!_.isString(suggestion) || !_.isString(video) || !_.isString(url)) {
            searchResult = []; // invalid result.
            break;
          }
        }
      }
    } catch (e) {
      return [];
    }
  }
  return searchResult;
};
